import React from 'react'
import Icon from './misc/Icon'
import * as Popover from '@radix-ui/react-popover';
import { Transition, animated, config } from 'react-spring'
import MoveDocPopoverContents from './MoveDocPopoverContents'

class MoveDocPopover extends React.Component{  	

	constructor(){
		super()
		this.onRest=this.onRest.bind(this)		
		this.state={
      forceMount: false,      
    }
	}

	onRest() {  
    if(!this.props.showPopover){
      this.setState({forceMount: false})
    } else{
      this.setState({forceMount: true})
    }
  }

	render(){	
		const {layout, showPopover, openPopover, closePopover} = this.props
		const {forceMount} = this.state
		
		let popoverSide
		let popoverSideOffset
		let popoverAlign
		let popoverAlignOffset
		if(layout === 'topMenu'){
			popoverSide = "bottom"
			popoverSideOffset= 4
			popoverAlign = "end"
			// popoverAlignOffset= -90
		}
		if(layout === 'topMenuPrivate'){
			popoverSide = "bottom"
			popoverSideOffset= 4
			popoverAlign = "end"
			// popoverAlignOffset= -40
		}
		if(layout === 'sideMenu'){
			popoverSide = "right"
			popoverSideOffset= -30
			popoverAlign = "start"
			// popoverAlignOffset= -40 
		}
		if(layout === 'docTableRow'){
			popoverSide = "right"
			popoverSideOffset= -30
			popoverAlign = "start"
			popoverAlignOffset= -40 
		}
		const translateY = -8
		
		return (
			<React.Fragment>
				<Popover.Root open={showPopover}>
					<Popover.Trigger asChild>
						{this.props.children}
					</Popover.Trigger>					
					<Popover.Portal forceMount={showPopover ? true : forceMount}>
						<Popover.Content
							className={'moveDocPopoverContainer ' + (layout ? ` moveDocPopoverContainer--layout--${layout} ` : ' ') + (showPopover ? ' moveDocPopoverContainer--visible ' : ' moveDocPopoverContainer--hidden ')} 
							onEscapeKeyDown={closePopover}
							onPointerDownOutside={closePopover}
							//onInteractOutside={closePopover}							
							side={popoverSide}
							sideOffset={popoverSideOffset}
							align={popoverAlign}
							alignOffset={popoverAlignOffset}
							forceMount={showPopover ? true : forceMount}
						>
							<Transition
								items={showPopover}
								from={{ opacity: 0, transform: `translateY(${translateY}px)` }}
								enter={{ opacity: 1, transform: 'translateY(0px)'  }}
								leave={{ opacity: 0, transform: `translateY(${translateY}px)`  }}
								reverse={showPopover}
								config={{tension: 600, friction: 35}}
								onRest={this.onRest}
							>
								{(styles, item) =>
									item && 
									 <animated.div style={styles} className="moveDocPopover popover"> 	
										<MoveDocPopoverContents 
											docId={this.props.docId}
											handleClosePopover={this.props.closePopover}
											showPopover={showPopover}
										/>
									</animated.div>
								}
							</Transition>									
						</Popover.Content>
					</Popover.Portal>
				</Popover.Root>		
			</React.Fragment>
		)
	}
}

export default MoveDocPopover